import { render, staticRenderFns } from "./jfRedemption.vue?vue&type=template&id=23573844&scoped=true"
import script from "./jfRedemption.vue?vue&type=script&lang=js"
export * from "./jfRedemption.vue?vue&type=script&lang=js"
import style0 from "./jfRedemption.vue?vue&type=style&index=0&id=23573844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23573844",
  null
  
)

export default component.exports